import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RestApiModel } from '../../../shared/model/rest-api.model';
import { PartCategoryModel } from '../model/part-category.model';

@Injectable()
export class PartCategoryService {
  private readonly partCategoriesURL =
    RestApiModel.PROXY_API_URL + '/partCategories';
  private readonly createPartCategoryURL = `${
    RestApiModel.PROXY_API_URL
  }/partCategory`;
  private readonly partCategoryURL = `${
    RestApiModel.PROXY_API_URL
  }/partCategory/`;

  constructor(private http: HttpClient) {}

  /**
   * GET - Obtain the list of part categories.
   * @returns {Observable<Array<PartCategoryModel>>}
   */
  getPartCategories(): Observable<Array<PartCategoryModel>> {
    return this.http.get(`${this.partCategoriesURL}`).pipe(
      map((res: any) => {
        return res.results ? res.results : [];
      }),
      catchError(error => Observable.of(error))
    );
  }

  /**
   * POST - Create a new part category.
   * @param {PartCategory} PartCategoryModel
   * @returns {Observable<any>}
   */
  createPartCategory(partCategoryModel: PartCategoryModel): Observable<any> {
    return this.http
      .post(this.createPartCategoryURL, partCategoryModel as any)
      .pipe(
        map((res: any) => res),
        catchError(this.handleError)
      );
  }

  /**
   * PUT - edit a part category.
   * @param {PartCategoryModel} PartCategoryModel
   * @returns {Observable<any>}
   */
  updatePartCategory(partCategoryModel: PartCategoryModel): Observable<any> {
    return this.http
      .put(
        this.partCategoryURL + partCategoryModel.id,
        partCategoryModel as any
      )
      .pipe(
        map((res: any) => res),
        catchError(this.handleError)
      );
  }

  /**
   * Resolves the given error as JSON object
   */
  private handleError(error: any) {
    console.log(error);
    return error;
  }
}
